import { API_URL, CONSULTANT_API_URL } from '../constants/config'
import { query } from './utilities'
import { request } from 'services/consultant/config'
import { checkConsultant } from '../helpers'

export const FetchFinAppStatusService = (opportunityId: string, finAppNumber: string, headers:any, httpVerb:any) => {
  if (checkConsultant()) {
    return request(`${CONSULTANT_API_URL}/Opportunity/finappstatus/${finAppNumber}`, headers, httpVerb)
  } else {
    return query(`${API_URL}/Opportunity/${opportunityId}/finappstatus/${finAppNumber}/oly`)
  }
}
